import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import {cleanNumber} from '../utilities/store.js';

// Debounce live Firestore .set() storms from title/DMV/form fields.
// Controlled search bars (value + onChange) stay immediate so filters feel instant.
const DEBOUNCE_MS = 400;

export default function TextLine(props) {
  const {data={}, id=""} = props;
  const defaultValue = data[id] || "";
  const [text, setText] = React.useState(defaultValue);
  const startCheck = defaultValue !== "";
  const [check, setChecked] = React.useState(startCheck);

  const propsRef = React.useRef(props);
  propsRef.current = props;
  const pendingRef = React.useRef(null);
  const timerRef = React.useRef(null);

  const persistNow = React.useCallback((value) => {
    const p = propsRef.current;
    if(!!p.onChange) return p.onChange(p.id, value);

    p.updater && p.updater(p.id, value);
    if(!p.drop_is) p.updater && p.updater("is_"+p.id, true);
  }, []);

  const flush = React.useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    if (!pendingRef.current) return;
    const { value } = pendingRef.current;
    pendingRef.current = null;
    persistNow(value);
  }, [persistNow]);

  const schedulePersist = React.useCallback((value) => {
    const p = propsRef.current;
    // Parent-controlled fields (search/filter) must see every keystroke.
    if (p.onChange && p.value !== undefined) {
      persistNow(value);
      return;
    }
    pendingRef.current = { value };
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(flush, DEBOUNCE_MS);
  }, [flush, persistNow]);

  React.useEffect(() => () => flush(), [flush]);

  React.useLayoutEffect(() => {
      const newCheck = text || ""
      setChecked(newCheck !== "")
  }, [text]);

  const onChange = (e) => {
    const value = props.type !== "number" ? e.target.value : cleanNumber(e.target.value);
    setText(`${value}` || "");
    schedulePersist(value || null);
  }

  const onBlur = (e) => {
    flush();
    if (props.onBlur) props.onBlur(e);
  }


  return (
    <div style={{
      backgroundColor: 'white', 
      padding: '17px', 
      width: '100%', 
      display: 'flex', 
      justifyContent: 'space-between',
      borderBottomWidth: '3px' 
    }}>
      {props.removeCheck || <FormControlLabel control={props.removeBox ? <></> : <Checkbox checked={props.check || check} onClick={props.onCheck} />} label={props.label} />}
      <TextField
          inputProps={{style: { textAlign: props.alignment || 'center'}}}
          style={{maxWidth: props.maxWidth || "30%", width:"50%"}}
          {...props}
          id={props.idOverride || props.id}
          label={""}
          type={props.type}
          value={props.value || text}
          onChange={onChange}
          onBlur={onBlur}
      />
    </div>
  );
}
